(function () {
  if (window.__CartUpsellUpgradeBound) return;
  window.__CartUpsellUpgradeBound = true;

  const APIPPA_VARIANT_ENDPOINT =
    "https://api.custompricecalculator.com/api/v1/variant";

  const MINI_CART_SECTION_ID = "mini-cart";

  function getHandleFromUrl(url) {
    const match = String(url || "").match(/\/products\/([^?/#]+)/);
    return match ? match[1] : "";
  }

  function getCartItemHandle(cartItem) {
    return getHandleFromUrl(cartItem && cartItem.url ? cartItem.url : "");
  }

  async function getCartSnapshot() {
    return fetch("/cart.js?t=" + Date.now(), {
      headers: { Accept: "application/json" },
    }).then(function (res) {
      if (!res.ok) throw new Error("Cart fetch failed");
      return res.json();
    });
  }

  function buildPropertiesFromCartItem(parentCartItem) {
    const properties = {};

    if (parentCartItem && parentCartItem.properties) {
      Object.keys(parentCartItem.properties).forEach(function (key) {
        const value = parentCartItem.properties[key];

        if (value === null || value === undefined || value === "") return;
        if (key.charAt(0) === "_") return;

        properties[key] = value;
      });
    }

    if (!properties.Shape) properties.Shape = "Diecut";
    if (!properties.Finish) properties.Finish = "Gloss";

    properties["_Upgraded from product"] = getCartItemHandle(parentCartItem);
    properties["_Upgraded from cart line key"] = parentCartItem.key || "";

    return properties;
  }

  async function createApippaVariant(upsellProduct, properties) {
    const response = await fetch(APIPPA_VARIANT_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        calculatorId: upsellProduct.calcId,
        productId: Number(upsellProduct.productId),
        properties: properties,
      }),
    });

    let data = null;

    try {
      data = await response.json();
    } catch (err) {
      data = null;
    }

    if (!response.ok) {
      throw new Error(
        (data && (data.message || data.description)) ||
          "Apippa variant create failed"
      );
    }

    const variantId =
      typeof data === "string" ? data : data && (data.variantId || data.id);

    if (!variantId) {
      throw new Error("Apippa se valid variant ID nahi mili");
    }

    return variantId;
  }

  async function addUpgradeToCart(upsellProduct, parentCartItem) {
    const properties = buildPropertiesFromCartItem(parentCartItem);
    const variantId = await createApippaVariant(upsellProduct, properties);

    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", "1");

    Object.keys(properties).forEach(function (key) {
      formData.append("properties[" + key + "]", properties[key]);
    });

    const cartAddRes = await fetch("/cart/add.js", {
      method: "POST",
      body: formData,
    });

    let cartAddJson = null;

    try {
      cartAddJson = await cartAddRes.json();
    } catch (err) {
      cartAddJson = null;
    }

    if (!cartAddRes.ok) {
      throw new Error(
        (cartAddJson &&
          (cartAddJson.description ||
            cartAddJson.message ||
            cartAddJson.status)) ||
          "Upgrade cart mein add nahi hui"
      );
    }

    return cartAddJson;
  }

  async function removeParentCartItem(parentCartItem) {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: parentCartItem.key,
        quantity: 0,
      }),
    });

    let data = null;

    try {
      data = await response.json();
    } catch (err) {
      data = null;
    }

    if (!response.ok) {
      throw new Error(
        (data && (data.description || data.message)) ||
          "Old product remove nahi hui"
      );
    }

    return data;
  }

  async function refreshMiniCartDrawer() {
    const cartJson = await getCartSnapshot();

    const sectionHtml = await fetch(
      "/cart?section_id=" +
        encodeURIComponent(MINI_CART_SECTION_ID) +
        "&t=" +
        Date.now()
    ).then(function (res) {
      return res.text();
    });

    const fakeDiv = document.createElement("div");
    fakeDiv.innerHTML = sectionHtml;

    const newCartDrawer = fakeDiv.querySelector("cart-drawer");
    const newCartDrawerHtml = newCartDrawer ? newCartDrawer.outerHTML : null;
    const currentCartDrawer = document.querySelector("cart-drawer");

    if (currentCartDrawer && newCartDrawerHtml) {
      const sections = {};
      sections[MINI_CART_SECTION_ID] = newCartDrawerHtml;

      currentCartDrawer.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: Object.assign({}, cartJson, {
              sections: sections,
            }),
            openMiniCart: true,
          },
        })
      );
    }

    const cartCountEl = document.querySelector("cart-count");
    if (cartCountEl) {
      cartCountEl.textContent = cartJson.item_count;
    }
  }

  function findCartItemByKey(cart, lineKey) {
    return (
      (cart.items || []).find(function (item) {
        return item.key === lineKey;
      }) || null
    );
  }

  function cartAlreadyHasHandle(cart, handle) {
    return (cart.items || []).some(function (item) {
      return getCartItemHandle(item) === handle;
    });
  }

  function getUpsellProductFromButton(btn) {
    const handle = btn.getAttribute("data-upsell-handle");
    const productId = btn.getAttribute("data-upsell-product-id");
    const calcId = btn.getAttribute("data-upsell-calc-id");

    if (!handle || !productId || !calcId) return null;

    return {
      handle: handle,
      productId: productId,
      calcId: calcId,
    };
  }

  document.body.addEventListener(
    "click",
    async function (event) {
      const btn = event.target.closest(
        "[data-best-deals-upsell-add], [data-deals-upsell-add]"
      );

      if (!btn || btn.disabled) return;

      event.preventDefault();

      const upsellHandle = btn.getAttribute("data-upsell-handle");
      const parentKey = btn.getAttribute("data-parent-key");
      const upsellProduct = getUpsellProductFromButton(btn);

      if (!upsellProduct || !upsellHandle || !parentKey) {
        alert("Upsell product data missing hai. Product ID / Calc ID check karein.");
        return;
      }

      const oldText = btn.textContent;
      btn.disabled = true;
      btn.textContent = "Upgrading...";

      try {
        const cartBefore = await getCartSnapshot();
        const parentCartItem = findCartItemByKey(cartBefore, parentKey);

        if (!parentCartItem) {
          throw new Error(
            "Parent cart item nahi mila. Cart refresh karke dobara try karein."
          );
        }

        if (cartAlreadyHasHandle(cartBefore, upsellHandle)) {
          await removeParentCartItem(parentCartItem);
          await refreshMiniCartDrawer();
          return;
        }

        await addUpgradeToCart(upsellProduct, parentCartItem);
        await removeParentCartItem(parentCartItem);
        await refreshMiniCartDrawer();
      } catch (err) {
        console.error("Cart upsell upgrade error:", err);
        alert(err.message || "Upgrade karte waqt issue aa gaya.");

        btn.disabled = false;
        btn.textContent = oldText;
      }
    },
    false
  );
})();